var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonIdealStockReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint0_radial_7252_94920)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7252_94920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8077 61.4587C33.7774 61.4587 27.7181 61.4587 21.6878 61.4587C18.2377 61.4587 16.7302 59.9512 16.7012 56.5301C16.7012 48.6153 16.7012 40.6716 16.7012 32.7568C16.7012 31.1333 17.136 29.7706 18.1798 28.495C20.5861 25.5958 22.9054 22.6386 25.2248 19.6525C26.1235 18.4928 27.2832 17.9709 28.7328 17.9709C36.2127 17.9709 43.7216 17.9999 51.2015 17.9709C52.5641 17.9709 53.6368 18.4638 54.4486 19.5365C57.0288 22.8416 59.6961 26.1177 62.2184 29.4517C62.7113 30.0895 62.9722 31.0463 62.9722 31.858C63.0302 40.3527 63.0302 48.8763 63.0012 57.3709C63.0012 59.7482 61.3486 61.3428 58.7974 61.4008C56.391 61.4587 53.9557 61.4298 51.5494 61.4298C47.6355 61.4877 43.7216 61.4877 39.8077 61.4587C39.8077 61.4877 39.8077 61.4877 39.8077 61.4587Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5859 28.7849C27.0507 28.7849 31.2255 28.7849 35.5163 28.7849C35.9222 26.4945 36.3281 24.2332 36.763 21.8268C33.9218 21.8268 31.2835 21.7978 28.6452 21.8558C28.3263 21.8558 27.9204 22.1167 27.7175 22.3777C26.036 24.4071 24.3834 26.4945 22.5859 28.7849Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0988 28.7269C48.5346 28.7269 52.7384 28.7269 57.2031 28.7269C55.3767 26.4365 53.6951 24.3491 52.0136 22.2617C51.8397 22.0588 51.5497 21.8268 51.3178 21.8268C48.5636 21.7979 45.7804 21.7979 42.9102 21.7979C43.316 24.2912 43.7219 26.4945 44.0988 28.7269Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6201 37.4824V36.4386C44.6201 35.105 43.5184 35.25 43.5184 35.25H35.9805C35.9805 35.25 34.8788 35.105 34.8788 36.4386V37.4824C34.8788 37.4824 34.4439 40.0046 37.691 40.0046H41.8078C45.0549 39.9757 44.6201 37.4824 44.6201 37.4824Z",
    fill: "#AEB5BE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7252_94920",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 7) rotate(66.1979) scale(79.7862)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7252_94920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.3,
    height: 43.4878,
    fill: "white",
    transform: "translate(16.6992 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonIdealStockReport);
export default __webpack_public_path__ + "static/media/nonIdeal-stockReport.64bc24e5003e802859117e551df1e0e5.svg";
export { ForwardRef as ReactComponent };